import forEach from "lodash/forEach";
import forOwn from "lodash/forOwn";
import Immutable from "immutable";
export default {
  convert(result) {
    const fieldNames = Immutable.Map().withMutations((map) => {
      forEach(result.messages, (msg) => {
        forOwn(msg.message, (_value, field) => {
          map.mergeWith((oldVal, newVal) => oldVal + newVal, Immutable.Map([[field, 1]]));
        });
      });
    });
    return {
      id: result.id,
      effectiveTimerange: result.effective_timerange,
      type: result.type,
      messages: result.messages,
      total: result.total_results,
      fields: fieldNames
      // computed fieldname -> occurrence count
    };
  }
};
